export default {
  maxLength(length) {
    return v => !v || v.length <= length || `Maksymalnie ${length} znaków`;
  },
  required(v) {
    return !!v || 'Wartość wymagana';
  },
};
